(function Index($, Adzuki)
{
	"use strict";

	var chart;
	var drawChart = true;

	$(document).ready(function documentReady()
	{
		Adzuki.onload('main/index', function onload()
		{
			var classic_loaded = false;
			var tasks_loaded   = false;
			var $calendar_container;
			var calendar_view  = Cookies.get('homepage_calendar_view') || '';

			$('.erez-home-vbtv').click(function homeVolumeByTourVendorClick() {
				initVolumeByTourVendorChart();
			});

			$('.erez-home-clients').click(function homeClients() {
				document.location = Adzuki.base_uri + '/Clients/view/' + $(this).data('id');
			});

			drawChart = false;
			chart = new Adzuki.Chart('#home-chart', {
				width: '100%'
			});

			$(chart).on('ready', function setChartData() {
				initHomePageChart();
			});

			// dashboard calendar
			$calendar_container = $(".homepage-calendar");

			if (calendar_view === '' || calendar_view === 'calendar') {
				initCalendar(true);
			} else {
				initCalendar(false);
			}

			$calendar_container.on('click', '.calendar-next-month, .calendar-prev-month', function changeMonth() {
				var date = reformatDate($(this).data('date'));
				Adzuki.QTip.hideAll();
				loadCalendar(date.day, date.month, date.year, true);
			});

			$calendar_container.on('click', '.calendar-thismonth', function thisMonthClick() {
				Adzuki.QTip.hideAll();
				initCalendar(true);

				Cookies.set('homepage_calendar_view', 'calendar');
			});

			$calendar_container.on('click', '.month-title', function monthClick() {
				document.location = Adzuki.base_uri + '/CalendarSearchIndex/index/' + $(this).data("month") + '/' + $(this).data("year");
			});

			$calendar_container.on('click', '.calendar-date', function calendarDateClick() {
				Adzuki.QTip.createOverlay();
			});

			$calendar_container.on('click', '.list-view', function calendarListViewClick(e) {
				e.preventDefault();
				Adzuki.QTip.hideAll();
				initCalendar(false);

				Cookies.set('homepage_calendar_view', 'list');
			});

			$calendar_container.on('click', '.calendar-view', function calendarCalendarViewClick(e) {
				e.preventDefault();
				Adzuki.QTip.hideAll();
				initCalendar(true);

				Cookies.set('homepage_calendar_view', 'calendar');
			});


			// upcoming opportunities
			$('.erez-home-opportunity').click(function homeOpportunities() {
				document.location = Adzuki.base_uri + '/ClientOpportunities/view/' + $(this).data('id');
			});

			// upcoming webinars
			$('.erez-home-upcoming-webinars').click(function homeWebinars() {
				var url = $(this).data("url");

				if (url !== '' && url !== undefined) {
					if (url.indexOf('http') === -1) {
						document.location = Adzuki.base_uri + url;
					} else {
						window.open(url);
					}
				}
			});

			// upcoming groups
			$('.erez-home-upcoming-groups').click(function homeGroups() {
				document.location = Adzuki.base_uri + '/Groups/manage/' + $(this).data('id');
			});

			// upcoming payments due
			$('.erez-upcoming-payments-due').click(function homePayments() {
				document.location = Adzuki.base_uri + '/' + $(this).data("url");
			});

			$('.erez-home-tbt').click(function homeTravelByTypeClick() {
				drawChart = true;
				initHomePageChart();
			});

			$('.erez-home-vbcv').click(function homeVolumeByCruiseVendorClick() {
				initVolumeByCruiseVendorChart();
			});

			// classic dashboard
			if ($('#classic-dashboard').hasClass('active')) {
				classic_loaded = true;
				loadClassicDashboard();
			} else {
				$('#classic-dashboard a').off().on('show.bs.tab', function onShowTab(e)
				{
					if (!classic_loaded) {
						classic_loaded = true;
						loadClassicDashboard();
					}
				});
			}

			// task manager dashboard
			if ($('#tasks-dashboard').hasClass('active')) {
				tasks_loaded = true;
				loadTaskManagerPanels();
			} else {
				$('#tasks-dashboard a').off().on('show.bs.tab', function onShowTab(e)
				{
					if (!tasks_loaded) {
						tasks_loaded = true;
						loadTaskManagerPanels();
					}
				});
			}

			$('#soar-dashboard a').off().on('show.bs.tab', function onShowTab(e)
			{
				loadSoarDashboard();
			});

			$('#homepage-ho-price-advantage').on('click', '.result-group-details', function showGroupDetails(e) {
				var group_id = $(this).data("group-id"),
					$modal   = $(".modal"),
					url      = '/GroupsHo/detail/' + group_id;

				e.preventDefault();

				$modal.addClass('wide');
				$modal.find('.modal-body').text('Loading Group Details...');

				if ($(this).hasClass('check-advantage')) {
					url = '/GroupsHo/detail/' + group_id + '/1';
				}

				Adzuki.Ajax.get(url)
				.then(function success(html) {
					$modal.find('.modal-body').html(html);
					$modal.find('[data-toggle^="tooltip"]').tooltip();
				});

				$modal.find('.modal-title').text('Group Details');
				$modal.on('hidden.bs.modal', function _restoreModal() {
					$modal.removeClass('wide').off('hidden.bs.modal');
				}).modal('show');
			});

			$('body').on('ajax-pagination.loaded', function onAjaxLoaded(e) {
				var $self        = $(e.target);
				var $tasks_table = $self.find('.table-header-sort').first();

				$('.task-details').off().on('click', openTaskDetails);
				$('.complete-task').off().on('click', completeTask);
				$('.pin-task').off().on('click', pinTask);
				$('.filter-criteria-toggle').off().on('click', toggleTaskFilterCriteria);

				// changed page on the pinned tasks
				if ($self.hasClass('box-content')) {
					Adzuki.TaskManager.sortTable($tasks_table, function callback(active_tab, page_num, order_by, sort_order)
					{
						loadPinnedTasks(active_tab, page_num, order_by, sort_order);
					});
				} else {
					// changed page on a filter panel
					Adzuki.TaskManager.sortTable($tasks_table, function callback(active_tab, page_num, order_by, sort_order)
					{
						var task_filter_id = $self.parents('.task-filter-panel').data('id');

						if (task_filter_id) {
							loadTaskFilterPanel(task_filter_id, active_tab, page_num, order_by, sort_order);
						}
					});
				}
			});

			$('#homepage-ho-price-advantage').on('click', '#filter-price-advantage', function _filterByPort(e) {
				var embarkation_port = $('#embarkation_port').val();

				e.preventDefault();

				loadHoPriceAdvantage(embarkation_port);
			});

			// charts
			loadTaskAnalysisChart();
			loadTaskTypeAnalysisChart();
			loadTaskPriorityAnalysisChart();
			loadHoPriceAdvantage();
		});
	});

	// functions here
	function initHomePageChart() {
		Adzuki.Ajax.get('/main/homepageReservationChart')
		.then(function loadHomepageReservationChar(response) {
			// console.log(response);
			if (response === null || response.length < 2 ) {
				$('#chart-options').removeClass('text-center');
				$('#chart-options').html('<div class="alert alert-info">We do not have enough data yet to create your charts. Check back later.</div>');
			} else {

				generateHomePageChart(response);
				chart.setData(response);
				chart.draw('line');
			}
		})
		.catch(function error(err) {
			console.log(err);
		});
	}

	function generateHomePageChart(jsonResponse) {
		chart.opts['title'] = "Travel by Type (next 6 months)";
		chart.opts['vAxis'] = {title: 'Number'};
		chart.opts['hAxis'] = {title: 'Months'};

		if (drawChart === true) {
			chart.opts['chartArea'] = null;
			chart.setData(jsonResponse);
			chart.draw('line');
		}
		return;
	}

	function initVolumeByCruiseVendorChart() {
		Adzuki.Ajax.get('/main/homePageVolumeByCruiseVendor')
		.then(function loadHomePageVolumeByCruiseVendor(response) {
			generateVolumeByCruiseVendor(response);
		})
		.catch(function error(err) {
			console.log(err);
		});
	}

	function generateVolumeByCruiseVendor(jsonResponse) {
		chart.opts['title']     = "Volume By Cruise Vendor (next 6 months)";

		chart.opts['chartArea'] = {
			width: '50%'
		};
		chart.opts['hAxis'] = {
			title   : 'Dollars',
			minValue: 0
		};
		chart.opts['vAxis'] = {
			title: 'Cruise Lines'
		};

		chart.setData(jsonResponse);
		chart.draw('bar');

		return;
	}

	function initVolumeByTourVendorChart() {
		Adzuki.Ajax.get('/main/homePageVolumeByTourVendor')
		.then(function loadHomePageVolumeByTourVendor(response) {
			generateVolumeByTourVendor(response);
		})
		.catch(function error(err) {
			console.log(err);
		});
	}

	function generateVolumeByTourVendor(jsonResponse) {
		chart.opts['title']     = "Volume By Tour Vendor (next 6 months)";

		chart.opts['chartArea'] = {
			width: '50%'
		};

		chart.opts['hAxis'] = {
			title   : 'Dollars',
			minValue: 0
		};

		chart.opts['vAxis'] = {
			title: 'Tour Companies'
		};

		chart.setData(jsonResponse);
		chart.draw('bar');

		return;
	}

	/** dashboard calendar */
	function initCalendar(calendar) {
		var date  = new Date(),
			month = date.getMonth(); // 0-indexed

		loadCalendar(date.getDate(), ++month, date.getFullYear(), calendar);
	}

	function loadCalendar(day, month, year, calendarFormat) {
		var url = '';

		if (calendarFormat === true) {
			url = '/CalendarSearchIndex/homepageCalendar/' + day + '/' + month + '/' + year;
		} else {
			url = '/CalendarSearchIndex/homepageListCalendar/' + day + '/' + month + '/' + year;
		}

		Adzuki.Ajax.get(url)
		.then(function loadCalendarSuccess(response) {
			if (!response.length) {
				throw new Error('operation failed');
			}

			$('.homepage-calendar').html(response);

			$('.calendar-date').click(function showDayEvents() {
				var $self   = $(this),
					daydate = $self.data('daydate'),
					date    = moment(daydate).format('MM/DD/YYYY'),
					$modal  = $(".modal");

					$modal.addClass('wide');
					$modal.find('.modal-body').text('Loading events for ' + date + '...');

					Adzuki.Ajax.get('/CalendarSearchIndex/eventsByDate/' + daydate)
						.then(function _showExcursions(html) {
							$modal.find('.modal-body').html(html);
							$modal.find('[data-toggle^="tooltip"]').tooltip();
					});

					$modal.find('.modal-title').text('Events for ' + date);
					$modal.on('hidden.bs.modal', function _restoreModal() {
						$modal.removeClass('wide').off('hidden.bs.modal');
					}).modal('show');
			});
		})
		.catch(function error(err) {
			console.log(err);
		});
	}

	function loadHoPriceAdvantage(embarkation_port) {
		$('#homepage-ho-price-advantage').html('<img id="time-period-loader" src="' + Adzuki.base_uri + '/adzuki/images/ajax-loader.gif"> Checking for price advantages...');

		Adzuki.Ajax.get(Adzuki.base_uri + '/main/homepagePriceAdvantage/' + embarkation_port)
		.then(function populatePriceAdvantage(response) {
			$('#homepage-ho-price-advantage').html(response);
		});
	}

	function reformatDate(dateString) {
		var date = dateString.split('-');

		return {
			day  : date[2],
			month: date[1],
			year : date[0],
		};
	}

	function loadPinnedTasks(active_tab, page_num, order_by, sort_order)
	{
		var pinned_page_num   = 1;
		var pinned_order_by   = 'due_date';
		var pinned_sort_order = 'asc';
		var pinned_url        = '';

		if (active_tab && page_num) {
			pinned_page_num = page_num;
			if (order_by && sort_order) {
				pinned_order_by   = order_by;
				pinned_sort_order = sort_order;
			}
		}

		pinned_url = '/Tasks/pinned/table_only:1/page_num:' + pinned_page_num;
		pinned_url += '/order_by:' + pinned_order_by;
		pinned_url += '/sort_order:' + pinned_sort_order;

		Adzuki.Ajax.get(pinned_url)
			.then(function populatePinnedTasks(response) {
				var $pinned_tasks_panel;

				$('.pinned-tasks-box .box-content').html(response);
				$('.task-details').off().on('click', openTaskDetails);
				$('.complete-task').off().on('click', completeTask);
				$('.pin-task').off().on('click', pinTask);
				$('.filter-criteria-toggle').off().on('click', toggleTaskFilterCriteria);

				$pinned_tasks_panel = $('.pinned-tasks-box .table-header-sort');

				Adzuki.TaskManager.sortTable($pinned_tasks_panel, function callback(active_tab, page_num, order_by, sort_order)
				{
					loadPinnedTasks(active_tab, page_num, order_by, sort_order);
				});
			}
		);
	}

	function loadTaskAnalysisChart() {
		var chart, data;

		if ($('#task-analysis').length === 0) {
			return;
		}

		chart = new Adzuki.Chart('#task-analysis', {
			title  : null,
			width  : '100%',
			pieHole: 0.6,
			vAxis  : {
				title: 'Segment'
			},
			chartArea: {
				width : '100%',
				height: '100%'
			},
			hAxis: {
				title: 'Tasks by Status'
			},
			colors    : ['#DFF0D8', '#FBF8E3', '#F27D79', '#F3DEDD', '#f6c7b6'], // eslint-disable-line key-spacing
			pieSliceTextStyle: {
				color: 'black'
			}
		});

		data = ([
			['Task', 'Hours per Day'],
			['Upcoming', 11],
			['Due Soon', 8],
			['Highly Past Due', 5],
			['Overdue', 2],
		]);

		$(chart).on('ready', function getChartData() {
			chart.setData(data);
			chart.draw('pie');
		});
	}

	function loadTaskFilterPanel(task_filter_id, active_tab, page_num, order_by, sort_order)
	{
		var all_page_num       = 1;
		var due_page_num       = 1;
		var due_today_page_num = 1;
		var due_week_page_num  = 1;
		var due_month_page_num = 1;

		var all_order_by       = 'due_date';
		var due_order_by       = 'due_date';
		var due_today_order_by = 'due_date';
		var due_week_order_by  = 'due_date';
		var due_month_order_by = 'due_date';

		var all_sort_order       = 'asc';
		var due_sort_order       = 'asc';
		var due_today_sort_order = 'asc';
		var due_week_sort_order  = 'asc';
		var due_month_sort_order = 'asc';

		var all_url       = '';
		var due_url       = '';
		var due_today_url = '';
		var due_week_url  = '';
		var due_month_url = '';

		var due_loaded       = false;
		var due_today_loaded = false;
		var due_week_loaded  = false;
		var due_month_loaded = false;

		if (active_tab && page_num) {
			switch (active_tab) {
				case 'all-tasks-tab-' + task_filter_id:
					all_page_num = page_num;
					if (order_by && sort_order) {
						all_order_by   = order_by;
						all_sort_order = sort_order;
					}
				break;
				case 'due-tasks-tab-' + task_filter_id:
					due_page_num = page_num;
					if (order_by && sort_order) {
						due_order_by   = order_by;
						due_sort_order = sort_order;
					}
				break;
				case 'today-tasks-tab-' + task_filter_id:
					due_today_page_num = page_num;
					if (order_by && sort_order) {
						due_today_order_by   = order_by;
						due_today_sort_order = sort_order;
					}
				break;
				case 'week-tasks-tab-' + task_filter_id:
					due_week_page_num = page_num;
					if (order_by && sort_order) {
						due_week_order_by   = order_by;
						due_week_sort_order = sort_order;
					}
				break;
				case 'month-tasks-tab-' + task_filter_id:
					due_month_page_num = page_num;
					if (order_by && sort_order) {
						due_month_order_by   = order_by;
						due_month_sort_order = sort_order;
					}
				break;
				default:
					// happy linter
			}
		}

		all_url = '/TaskFilters/getTasks/' + task_filter_id;
		all_url += '/page_num:' + all_page_num;
		all_url += '/order_by:' + all_order_by;
		all_url += '/sort_order:' + all_sort_order;

		Adzuki.Ajax.get(all_url)
			.then(function populateFilterTasks(response) {
				$('#all-tasks-tab-' + task_filter_id).html(response);
				$('.task-details').off().on('click', openTaskDetails);
				$('.complete-task').off().on('click', completeTask);
				$('.pin-task').off().on('click', pinTask);
				$('.filter-criteria-toggle').off().on('click', toggleTaskFilterCriteria);

				Adzuki.TaskManager.sortTable($('#all-tasks-tab-' + task_filter_id + ' .table-header-sort'), function callback(active_tab, page_num, order_by, sort_order)
				{
					loadTaskFilterPanel(task_filter_id, active_tab, page_num, order_by, sort_order);
				});
			}
		);

		due_url = '/TaskFilters/getTasks/' + task_filter_id + '/past_due';
		due_url += '/page_num:' + due_page_num;
		due_url += '/order_by:' + due_order_by;
		due_url += '/sort_order:' + due_sort_order;

		$('#due-tasks-tab-link-' + task_filter_id).off().on('show.bs.tab', function onShowTab(e)
		{
			if (!due_loaded) {
				due_loaded = true;

				Adzuki.Ajax.get(due_url)
					.then(function populateFilterTasks(response) {
						$('#due-tasks-tab-' + task_filter_id).html(response);
						$('.task-details').off().on('click', openTaskDetails);
						$('.complete-task').off().on('click', completeTask);
						$('.pin-task').off().on('click', pinTask);
						$('.filter-criteria-toggle').off().on('click', toggleTaskFilterCriteria);

						Adzuki.TaskManager.sortTable($('#due-tasks-tab-' + task_filter_id + ' .table-header-sort'), function callback(active_tab, page_num, order_by, sort_order)
						{
							loadTaskFilterPanel(task_filter_id, active_tab, page_num, order_by, sort_order);
						});
					}
				);
			}
		});

		due_today_url = '/TaskFilters/getTasks/' + task_filter_id + '/today_due';
		due_today_url += '/page_num:' + due_today_page_num;
		due_today_url += '/order_by:' + due_today_order_by;
		due_today_url += '/sort_order:' + due_today_sort_order;

		$('#today-tasks-tab-link-' + task_filter_id).off().on('show.bs.tab', function onShowTab(e)
		{
			if (!due_today_loaded) {
				due_today_loaded = true;

				Adzuki.Ajax.get(due_today_url)
					.then(function populateFilterTasks(response) {
						$('#today-tasks-tab-' + task_filter_id).html(response);
						$('.task-details').off().on('click', openTaskDetails);
						$('.complete-task').off().on('click', completeTask);
						$('.pin-task').off().on('click', pinTask);
						$('.filter-criteria-toggle').off().on('click', toggleTaskFilterCriteria);

						Adzuki.TaskManager.sortTable($('#today-tasks-tab-' + task_filter_id + ' .table-header-sort'), function callback(active_tab, page_num, order_by, sort_order)
						{
							loadTaskFilterPanel(task_filter_id, active_tab, page_num, order_by, sort_order);
						});
					}
				);
			}
		});

		due_week_url = '/TaskFilters/getTasks/' + task_filter_id + '/week_due';
		due_week_url += '/page_num:' + due_week_page_num;
		due_week_url += '/order_by:' + due_week_order_by;
		due_week_url += '/sort_order:' + due_week_sort_order;

		$('#week-tasks-tab-link-' + task_filter_id).off().on('show.bs.tab', function onShowTab(e)
		{
			if (!due_week_loaded) {
				due_week_loaded = true;

				Adzuki.Ajax.get(due_week_url)
					.then(function populateFilterTasks(response) {
						$('#week-tasks-tab-' + task_filter_id).html(response);
						$('.task-details').off().on('click', openTaskDetails);
						$('.complete-task').off().on('click', completeTask);
						$('.pin-task').off().on('click', pinTask);
						$('.filter-criteria-toggle').off().on('click', toggleTaskFilterCriteria);

						Adzuki.TaskManager.sortTable($('#week-tasks-tab-' + task_filter_id + ' .table-header-sort'), function callback(active_tab, page_num, order_by, sort_order)
						{
							loadTaskFilterPanel(task_filter_id, active_tab, page_num, order_by, sort_order);
						});
					}
				);
			}
		});

		due_month_url = '/TaskFilters/getTasks/' + task_filter_id + '/month_due';
		due_month_url += '/page_num:' + due_month_page_num;
		due_month_url += '/order_by:' + due_month_order_by;
		due_month_url += '/sort_order:' + due_month_sort_order;

		$('#month-tasks-tab-link-' + task_filter_id).off().on('show.bs.tab', function onShowTab(e)
		{
			if (!due_month_loaded) {
				due_month_loaded = true;

				Adzuki.Ajax.get(due_month_url)
					.then(function populateFilterTasks(response) {
						$('#month-tasks-tab-' + task_filter_id).html(response);
						$('.task-details').off().on('click', openTaskDetails);
						$('.complete-task').off().on('click', completeTask);
						$('.pin-task').off().on('click', pinTask);
						$('.filter-criteria-toggle').off().on('click', toggleTaskFilterCriteria);

						Adzuki.TaskManager.sortTable($('#month-tasks-tab-' + task_filter_id + ' .table-header-sort'), function callback(active_tab, page_num, order_by, sort_order)
						{
							loadTaskFilterPanel(task_filter_id, active_tab, page_num, order_by, sort_order);
						});
					}
				);
			}
		});

		// handlers for filter configuration
		$('.update-filter-settings-btn').off().on('click', openTaskFilterSettings);
		$('.replace-filter-btn').off().on('click', openTaskFilterReplaceForm);
		$('.remove-from-dashboard-btn').off().on('click', removeTaskFilterFromDashboard);
	}

	function loadTaskTypeAnalysisChart() {
		var chart, data;

		if ($('#task-type-analysis').length === 0) {
			return;
		}

		chart = new Adzuki.Chart('#task-type-analysis', {
			title  : null,
			width  : '100%',
			pieHole: 0.6,
			vAxis  : {
				title: 'Segment'
			},
			chartArea: {
				width : '100%',
				height: '100%'
			},
			hAxis: {
				title: 'Tasks by Status'
			},
			colors    : ['#DFF0D8', '#FBF8E3', '#F27D79', '#F3DEDD', '#f6c7b6'], // eslint-disable-line key-spacing
			pieSliceTextStyle: {
				color: 'black'
			}
		});

		data = ([
			['Task', 'Hours per Day'],
			['Reservation', 25],
			['Client', 15],
			['Group', 3],
			['Operational', 8],
		]);

		$(chart).on('ready', function getChartData() {
			chart.setData(data);
			chart.draw('pie');
		});
	}

	function loadTaskPriorityAnalysisChart() {
		var chart, data;

		if ($('#task-priority-analysis').length === 0) {
			return;
		}

		chart = new Adzuki.Chart('#task-priority-analysis', {
			title  : null,
			width  : '100%',
			pieHole: 0.6,
			vAxis  : {
				title: 'Segment'
			},
			chartArea: {
				width : '100%',
				height: '100%'
			},
			hAxis: {
				title: 'Tasks by Status'
			},
			colors    : ['#DFF0D8', '#FBF8E3', '#F27D79', '#F3DEDD', '#f6c7b6'], // eslint-disable-line key-spacing
			pieSliceTextStyle: {
				color: 'black'
			}
		});

		data = ([
			['Task', 'Hours per Day'],
			['High', 11],
			['Medium', 8],
			['Low', 25],
		]);

		$(chart).on('ready', function getChartData() {
			chart.setData(data);
			chart.draw('pie');
		});
	}

	function loadTaskManagerPanels(active_tab, page_num, order_by, sort_order)
	{
		// pinned tasks panel
		if ($('.pinned-tasks-box').length > 0) {
			loadPinnedTasks(active_tab, page_num, order_by, sort_order);
		}

		// today's tasks panel
		if ($('.today-tasks-box').length > 0) {
			loadTodaysTasks();
		}

		// dragging the filter panels
		if ($('#task-filters-container .task-filter-panel').length > 1) {
			handleTaskFiltersSorting();
		}

		// filter panels
		$('.task-filter-panel').each(function onEachFilter(i, elem)
		{
			var task_filter_id = $(elem).data('id');

			loadTaskFilterPanel(task_filter_id, active_tab, page_num, order_by, sort_order);
		});
	}

	function loadSoarDashboard()
	{
		$('#soar').trigger('loadSoar');
	}

	function loadClassicDashboard()
	{
		// loaders
		$('.home-notifications-container').html('<img id="time-period-loader" src="' + Adzuki.base_uri + '/adzuki/images/ajax-loader.gif"> Loading recent activity...');
		$('.home-hot-list').html('<img id="time-period-loader" src="' + Adzuki.base_uri + '/adzuki/images/ajax-loader.gif"> Loading hot list...');
		$('.home-current-reservation-activity').html('<img id="time-period-loader" src="' + Adzuki.base_uri + '/adzuki/images/ajax-loader.gif"> Loading current reservation activity...');
		$('.home-recent-reservation-activity').html('<img id="time-period-loader" src="' + Adzuki.base_uri + '/adzuki/images/ajax-loader.gif"> Loading recent reservation activity...');
		$('#homepage-today-tasks-tab').html('<img id="time-period-loader" src="' + Adzuki.base_uri + '/adzuki/images/ajax-loader.gif"> Loading today\'s tasks...');

		// notifications panel
		Adzuki.Ajax.get(Adzuki.base_uri + '/main/homepageRecentActivity')
			.then(function _loadRecentActivity(response) {
				$('.home-notifications-container').html(response);

				$('.home-notifications-container').on('click', '.erez-home-notifications', function notificationCenterLinks() {
					if ($(this).data("link") !== '' && $(this).data("link") !== undefined) {
						document.location = $(this).data('link');
					}
				});
			}
		);

		// hot-list
		Adzuki.Ajax.get(Adzuki.base_uri + '/main/homepageHotList')
			.then(function _loadHotList(response) {
				$('.home-hot-list').html(response);
			}
		);

		// current reservation activity
		Adzuki.Ajax.get(Adzuki.base_uri + '/main/homepageCurrentReservationActivity')
			.then(function _loadCurrentReservationActivity(response) {
				$('.home-current-reservation-activity').html(response);

				$('.home-current-reservation-activity').on('click', '.erez-home-reservations', function homeReservations() {
					document.location = Adzuki.base_uri + '/Reservations/manage/' + $(this).data('id');
				});
			}
		);

		// recent reservation activity
		Adzuki.Ajax.get(Adzuki.base_uri + '/main/homepageRecentReservationActivity')
			.then(function _loadCurrentReservationActivity(response) {
				$('.home-recent-reservation-activity').html(response);

				$('.home-recent-reservation-activity').on('click', '.erez-home-reservations', function homeReservations() {
					document.location = Adzuki.base_uri + '/Reservations/manage/' + $(this).data('id');
				});
			}
		);

		// cp specialist programs
		Adzuki.Ajax.get(Adzuki.base_uri + '/main/homepageSpecialistPrograms')
			.then(function _loadSpecialistPrograms(response) {
				$('.home-specialist-programs').html(response);
			}
		);

		// today tasks
		loadHomepageTodayTasks();
	}

	function loadHomepageTodayTasks()
	{
		Adzuki.Ajax.get(Adzuki.base_uri + '/main/homepageTodayTasks')
			.then(function homepageTodayTasks(response) {
				$('#homepage-today-tasks-tab').html(response);
				$('#homepage-today-tasks-tab .task-details').off().on('click', openTaskDetails);
				$('#homepage-today-tasks-tab .complete-task').off().on('click', homepageCompleteTask);
				$('#homepage-today-tasks-tab .pin-task').off().on('click', homepagePinTask);
			}
		);
	}

	function loadTodaysTasks()
	{
		var todays_url = '/Tasks/dueTodayDashboard';

		Adzuki.Ajax.get(todays_url)
			.then(function populateTodaysTasks(response) {
				$('.today-tasks-box .box-content').html(response);
				$('.task-details').off().on('click', openTaskDetails);
				$('.complete-task').off().on('click', completeTask);
				$('.pin-task').off().on('click', pinTask);
				handleTasksSorting();
			}
		);
	}

	function handleTasksSorting()
	{
		var container = document.querySelector('#today-tasks-tab ul.table');
		var drake     = dragula([container], {
			moves: function dragulaMoves(el, container, handle) {
				var $task = $(handle).parents('li.table-row');
				return $task.length > 0;
			},
			accepts: function dragulaAccepts(el, target, source, sibling) {
				if ($(sibling).hasClass('table-header')) {
					return false;
				}
				return true;
			},
		});

		drake.on('drop', function onDrop(el, target, source, sibling)
		{
			var sort_order = [];

			$('#today-tasks-tab li.table-row').each(function onEachTask(i, elem)
			{
				sort_order.push($(elem).data('task-id'));
			});

			Adzuki.Ajax.post('/Tasks/saveOrder', { order: sort_order });
		});
	}

	function handleTaskFiltersSorting()
	{
		var drake = dragula([document.getElementById('task-filters-container')], {
			moves: function dragulaMoves(el, container, handle) {
				var $filter_header = $(handle).parents('.filter-box-header');
				return $filter_header.length > 0;
			}
		});

		drake.on('drop', function onDrop(el, target, source, sibling)
		{
			var sort_order = [];

			$('#task-filters-container .task-filter-panel').each(function onEachPanel(i, elem)
			{
				sort_order.push($(elem).data('id'));
			});

			Adzuki.Ajax.post('/TaskFilters/saveOrder', { order: sort_order});
		});

		drake.on('drag', function onDrag(el, source)
		{
			$(el).find('.box-content').addClass('hidden');
		});

		drake.on('dragend', function onDragend(el)
		{
			$(el).find('.box-content').removeClass('hidden');
		});

		autoScroll([
			window,
			document.querySelector('#task-filters-container')
		], {
			margin    : 50,
			pixels    : 20,
			maxSpeed  : 20,
			autoScroll: function autoScrolling() {
				return this.down && drake.dragging;
			}
		});
	}

	function homepageCompleteTask(e)
	{
		var $check_elem = $(this);

		e.preventDefault();

		Adzuki.TaskManager.completeTask($check_elem, function completeTaskCb() {
			loadHomepageTodayTasks();
		});
	}

	function homepagePinTask(e)
	{
		var $pin_elem = $(this);

		e.preventDefault();

		Adzuki.TaskManager.pinTask($pin_elem, function pinTaskCb() {
			loadHomepageTodayTasks();
		});
	}

	function completeTask(e)
	{
		var $check_elem = $(this);

		e.preventDefault();

		Adzuki.TaskManager.completeTask($check_elem, function completeTaskCb(active_tab, page_num, order_by, sort_order) {
			reloadActivePanel(active_tab, page_num, order_by, sort_order);
			updateTabNumbers();
		});
	}

	function pinTask(e)
	{
		var $pin_elem = $(this);

		e.preventDefault();

		Adzuki.TaskManager.pinTask($pin_elem, function pinTaskCb(active_tab, page_num, order_by, sort_order) {
			updateTabNumbers();
			reloadActivePanel(active_tab, page_num, order_by, sort_order);
		});
	}

	function openTaskDetails(e)
	{
		var $anchor_elem = $(this);

		e.preventDefault();

		Adzuki.TaskManager.openTaskDetails($anchor_elem);
	}

	function openTaskFilterReplaceForm(e)
	{
		var $self      = $(this);
		var $container = $self.parents('.task-filter-panel');
		var filter_id  = $container.data('id');

		e.preventDefault();

		if (!filter_id) {
			return;
		}

		// make sure only 1 replace filter form is open at a time
		$('#task-filters-container .task-filter-panel').each(function onEachFilter(i, el) {
			var $replace_form = $(el).find('.task-filter-replace').first();

			if (!$replace_form.hasClass('hidden')) {
				$replace_form.addClass('hidden').html('Loading replace task filter panel form...');
				$(el).find('.task-filter-tasks').first().removeClass('hidden');
			}
		});

		$container.find('.task-filter-tasks').first().addClass('hidden');
		$container.find('.task-filter-settings').first().addClass('hidden').html('Loading task filter panel settings form...');
		$container.find('.task-filter-replace').first().removeClass('hidden').html('Loading replace task filter panel form...');

		// render the form
		Adzuki.Ajax.get('/TaskFilters/replace/' + filter_id)
			.then(function replaceFilter(response) {
				$container.find('.task-filter-replace').first().html(response);

				Adzuki.Form.initAjaxForm('TaskFilterReplace');
			});
	}

	function openTaskFilterSettings(e)
	{
		var $self      = $(this);
		var $container = $self.parents('.task-filter-panel');
		var filter_id  = $container.data('id');

		e.preventDefault();

		if (!filter_id) {
			return;
		}

		// make sure only the settings for 1 filter are open at a time
		$('#task-filters-container .task-filter-panel').each(function onEachFilter(i, el) {
			var $filter_settings = $(el).find('.task-filter-settings').first();

			if (!$filter_settings.hasClass('hidden')) {
				$filter_settings.addClass('hidden').html('Loading task filter panel settings form...');
				$(el).find('.task-filter-tasks').first().removeClass('hidden');
			}
		});

		$container.find('.task-filter-tasks').first().addClass('hidden');
		$container.find('.task-filter-replace').first().addClass('hidden').html('Loading replace task filter panel form...');
		$container.find('.task-filter-settings').first().removeClass('hidden').html('Loading task filter panel settings form...');

		// render the form
		Adzuki.Ajax.get('/TaskFilters/updateSettings/' + filter_id)
			.then(function updateSettings(response) {
				$container.find('.task-filter-settings').first().html(response);

				Adzuki.Form.initAjaxForm('TaskFilterSettings');
			});
	}

	function toggleTaskFilterCriteria(e)
	{
		var $toggle_elem = $(this),
		    toggle_action = $toggle_elem.data('action');

		e.preventDefault();

		if (toggle_action === 'more') {
			$('.additional-filter-criteria').removeClass('hidden');
			$('.filter-less').removeClass('hidden');
			$('.filter-more').addClass('hidden');
		} else {
			$('.additional-filter-criteria').addClass('hidden');
			$('.filter-more').removeClass('hidden');
			$('.filter-less').addClass('hidden');
		}
	}

	function removeTaskFilterFromDashboard(e)
	{
		var $self      = $(this);
		var $container = $self.parents('.task-filter-panel');
		var filter_id  = $container.data('id');

		e.preventDefault();

		Adzuki.CustomConfirm({
			body   : 'This will remove the task filter panel from your Task Manager Dashboard. This will NOT delete the task filter. Do you wish to proceed?',
			confirm: function confirmSubmit() {
				Adzuki.Ajax.post('/TaskFilters/removeFromDashboard/', { filter_id: filter_id })
					.then(function removeFromDashboard(response) {
						var $filter_panel = $('.task-filter-panel.task-filter-' + filter_id);

						$filter_panel.fadeOut(400, function onFadeout() {
							$filter_panel.remove();
							Adzuki.StatusMessage('success', 'Your task filter panel has been removed from the Task Manager Dashboard');
						});
					});
			}
		});
	}

	function reloadActivePanel(panel, page_num, order_by, sort_order)
	{
		var task_filter_id = null;

		if (panel === 'tasks' || panel === 'today-tasks-tab') {
			// clicked on the pinned or today's tasks, update everything
			loadTaskManagerPanels(panel, page_num, order_by, sort_order);
		} else {
			loadPinnedTasks(null, 1);
			loadTodaysTasks();

			// update the changed task filter panel
			task_filter_id = $('#' + panel).parents('.task-filter-panel').data('id');

			if (task_filter_id) {
				loadTaskFilterPanel(task_filter_id, panel, page_num, order_by, sort_order);

				if ($('#due-tasks-tab-link-' + task_filter_id).length > 0) {
					$('#due-tasks-tab-link-' + task_filter_id).trigger('show.bs.tab');
				}

				$('#today-tasks-tab-link-' + task_filter_id).trigger('show.bs.tab');
				$('#week-tasks-tab-link-' + task_filter_id).trigger('show.bs.tab');
				$('#month-tasks-tab-link-' + task_filter_id).trigger('show.bs.tab');
			}
		}
	}

	function updateTabNumbers()
	{
		// filter panels
		$('.task-filter-panel').each(function onEachFilter(i, elem)
		{
			var task_filter_id = $(elem).data('id');

			Adzuki.Ajax.get('/TaskFilters/getTasksCounts/' + task_filter_id)
				.then(function getTasksCounts(response) {
					// update badge numbers
					$('#all-tasks-tab-link-' + task_filter_id + ' .badge').text(response.all_count);
					$('#due-tasks-tab-link-' + task_filter_id + ' .badge').text(response.past_due_count);
					$('#week-tasks-tab-link-' + task_filter_id + ' .badge').text(response.week_due_count);
					$('#month-tasks-tab-link-' + task_filter_id + ' .badge').text(response.month_due_count);

					// hide past due tab if 0
					if (response.past_due_count === 0) {
						$('#due-tasks-tab-link-' + task_filter_id).addClass('hidden');
						$('#all-tasks-tab-link-' + task_filter_id).trigger('click');
					}
				}
			);
		});
	}

}(jQuery, window.Adzuki || {}));
